/* eslint-disable */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import CopyToClipboard from './utils/CopyToClipboard';
import LinkableTitle from './linkableTitle';

class Icons extends Component {
  state = {
    filter: '',
  };

  componentDidMount() {
    this._input.focus();
  }

  render() {
    return <StaticQuery
      query={graphql`
        query IconsQuery {
          iconsJson {
            icons
          }
        }
      `}
      render={({ iconsJson: { icons } }) => {
        const { filter } = this.state;
        const filteredIcons = filter.trim() === '' ? icons : icons.filter(i => i.indexOf(filter) !== -1);
        return (
          <div className="tds-icons">
            <input
              type="text"
              className="color-input tes-control"
              placeholder="Type an icon name"
              value={filter}
              ref={input => (this._input = input)}
              onChange={evt => this.setState({ filter: evt.target.value })}
              style={{ marginBottom: 20 }}
            />
            <hr />
            {filteredIcons.length === 0 && <div className="error">No icons found (sadmorgantini)</div>}
            {filteredIcons.length > 0 && (
              <div style={{ position: 'relative' }}>
                {filteredIcons.map(icon => (
                  <CopyToClipboard key={icon} clipboardText={`@include generate-icon(${icon}, colorVariable)`}>
                    <div className="icon-square">
                      <i className={`icon icon-${icon}`} />
                      <span>{icon}</span>
                    </div>
                  </CopyToClipboard>
                ))}
              </div>
            )}
            {filteredIcons.length > 0 && (
              <div>
                <br />
                <p>
                  By clicking on the icon box the string to generate it on your scss will be copied to clipboard. 
                </p>
              </div>
            )}
          </div>
        );
      }}
    />
  }
}

export default Icons;
